import scrollToTop from "./scrollTop";

function subtractQuestion(store) {
  scrollToTop();

  setTimeout(() => {
    store.commit("decreaseCurrentPage")
  }, 500)
}

export default subtractQuestion;